<template>
  <div id="app">
    <v-app>
      <!-- Navigation TOP -->
      <v-navigation-drawer
        v-if="navHasCollapsed"
        app
        permanent
        clipped
        mini-variant-width="100"
        :mini-variant="mini"
        :class="navHasCollapsed ? 'nav-background no-animation nav-background-img' : 'nav-background no-animation nav-background-color'"
      >
        <div class="logo-container"> 
          <a href="https://www.th-wildau.de/30jahre/" target="_blank">
            <img src="../assets/img/TH_Wildau_Logo_white.png">
          </a>
          <div style="backgroud-color:rgb(20,20,50)"></div>
        </div>
        <v-list nav id="nav-list">
          <v-list-item
            class="nav-list-item"
            v-for="route in navigationRoutes"
            :key="route.key"
            :to="route.to"

            active-class="nav-item-activ"
          >
            <v-list-item-content>
              <v-list-item-title class="font-18px">
                {{route.name}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="nav-list-item"
            active-class="nav-item-activ"
            href="https://www.th-wildau.de/30jahre/"
          >
            <v-list-item-content>
              <v-list-item-title class="font-18px">
                {{ $t("30years") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <!-- <div class="about-text-nav">
          Seit Gründung der TH Wildau im Jahre 1991 wurde von jeder Abschlussarbeit ein Pflichtexemplar in den Bestand der Hochschulbibliothek gegeben. Mit dieser interaktiven Anwendung können die erschlossenen Daten von 14.000 Abschlussarbeiten auf einer virtuellen Zeitschiene Entwicklungen, Tendenzen und Schwerpunkte der Abschlussarbeiten qualitativ und quantitativ dargestellt werden.
        </div> -->

        <v-list
          nav
          dense
          class="row justify-content-start fixed-bottom"
        >
          <v-list-item link :class="navHasCollapsed ? 'col-xl-5' : ''" :href="link.url" target="_blank"> 
            <v-list-item-subtitle class="pa-3 nav-text"> {{this.$t("imprint")}}</v-list-item-subtitle>
          </v-list-item>
          <v-list-item :class="navHasCollapsed ? 'col-xl-5' : ''"> 
            <v-list-item-subtitle class="pa-3 text-right beta"> BETA</v-list-item-subtitle>
          </v-list-item>
        </v-list>

      </v-navigation-drawer >
      <!-- Navigation BOTTOM -->
      
      <v-app-bar 
        v-if="!navHasCollapsed"
         style="max-height: 55px;">

      <v-toolbar-title>{{selectedNavigationRoute}}</v-toolbar-title>

      <v-app-bar-nav-icon class="floate-right" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
     
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      class="nav-background no-animation nav-background-img full-height"
    >
      <div class="logo-container"> 
          <a href="https://www.th-wildau.de/30jahre/" target="_blank">
            <img src="../assets/img/TH_Wildau_Logo_white.png">
          </a>
          <div style="backgroud-color:rgb(20,20,50)"></div>
      </div>
      <v-list nav id="nav-list">
          <v-list-item
           
            class="nav-list-item"
            v-for="route in navigationRoutes"
            :key="route.key"
            :to="route.to"

            active-class="nav-item-activ"
          >
            <v-list-item-content @click="selectedNavigationRoute = route.name">
              <v-list-item-title class="font-18px">
                {{route.name}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="nav-list-item"
            active-class="nav-item-activ"
            href="https://www.th-wildau.de/30jahre/"
          >
            <v-list-item-content>
              <v-list-item-title class="font-18px">
                {{ $t("30years") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <!-- <div class="about-text-nav">
          Seit Gründung der TH Wildau im Jahre 1991 wurde von jeder Abschlussarbeit ein Pflichtexemplar in den Bestand der Hochschulbibliothek gegeben. Mit dieser interaktiven Anwendung können die erschlossenen Daten von 14.000 Abschlussarbeiten auf einer virtuellen Zeitschiene Entwicklungen, Tendenzen und Schwerpunkte der Abschlussarbeiten qualitativ und quantitativ dargestellt werden.
        </div> -->

        <v-list
          nav
          dense
          class="row justify-content-start fixed-bottom fixed-bottom-vh"
        >
          <v-list-item :class="navHasCollapsed ? 'col-xl-5' : ''" :href="link.url"> 
            <v-list-item-subtitle class="pa-3 nav-text"> {{this.$t("imprint")}}</v-list-item-subtitle>
          </v-list-item>
          <v-list-item :class="navHasCollapsed ? 'col-xl-5' : ''"> 
            <v-list-item-subtitle class="pa-3 text-right beta"> BETA</v-list-item-subtitle>
          </v-list-item>
        </v-list>
    </v-navigation-drawer>

      <v-main>
        <router-view></router-view>
      </v-main>
    </v-app>
  </div>
</template>

<script>

export default {
  name: "app",
  data() {
    return {
      link:{
        url: "https://www.th-wildau.de/impressum/"
      },
      drawer: false,
      window: {
        width: 0,
        height: 0
      },
      selectedNavigationRoute: this.$t("start_page"),
      navigationRoutes: [
        {
          key: "startpage",
          name: this.$t("start_page"),
          to: "/home",
        },
        {
          key: "dashboard",
          name: this.$t("dashboard"),
          to: "/dashboard",
        },
        {
          key: "about",
          name: this.$t("about"),
          to: "/about",
        }
      ],
    };
  },

  mounted() {
    this.$router.push("home");
    
    showLoadingCircle(false);
  },
  created() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  computed: {
    mini() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    navHasCollapsed() {
      return this.window.width > 1263;
    }
  },

  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      //this.filterKeywordsText();
      //this.evaluaionHint();
    },
    openThirtyYears(){
      window.open("https://www.th-wildau.de/30jahre/", '_blank').focus();
    },
  },
  watch: {
    $route(to, from) {
      // if (from.path === "/login" && to.path !== "/reset-password") {
      //   this.getCurrentUser();
      // }
    },
  },
};
</script>
